import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import { FormControl } from 'react-bootstrap';
import { connect } from 'react-redux';

// Locale
import messages from '../../locale/messages';
import { getAutocompleteLocations } from '../../actions/autocompleteLocations';

class StateList extends Component {
  static propTypes = {
    input: PropTypes.object.isRequired,
    className: PropTypes.string,
    isEmptyFirst: PropTypes.bool,
    formatMessage: PropTypes.any,
    dispatch: PropTypes.func.isRequired
  };

  static defaultProps = {
    isEmptyFirst: false
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      locations: []
    };
  }

  async componentDidMount() {
    const { dispatch } = this.props;
    
    if (!dispatch) {
      this.setState({ loading: false });
      return;
    }
    
    try {
      const locations = await dispatch(getAutocompleteLocations());
      this.setState({ 
        locations: locations || [],
        loading: false 
      });
    } catch (error) {
      this.setState({ 
        locations: [],
        loading: false 
      });
    }
  }

  render() {
    const { className, input, isEmptyFirst } = this.props;
    const { formatMessage } = this.props.intl;
    const { loading, locations } = this.state;

    return (
      <div>
        <FormControl 
          componentClass="select"
          className={className}
          {...input}
        >
          {loading && <option>{formatMessage(messages.loadingLabel)}</option>}
          
          {!loading && isEmptyFirst && (
            <option value="">{formatMessage(messages.state)}</option>
          )}
          
          {!loading && locations && locations.length > 0 && locations.map((location, index) => (
            <option value={location} key={index}>{location}</option>
          ))}
        </FormControl>
      </div>
    );
  }
}

const mapState = (state) => ({});

export default compose(
  injectIntl,
  connect(mapState)
)(StateList);